import React, { Component } from 'react';
import axios from 'axios'
import { Button, Card, Table } from 'react-bootstrap'
import { connect } from 'react-redux';

class AdminPrices extends Component {
    state = {
        pricesFormatted: [],

    }
    componentDidMount() {
        axios.get('/api/prices/get-all').then((resp) => {
            let pricesFormatted = this.state.pricesFormatted
            resp.data.prices.forEach(price => {
                pricesFormatted.push({ 'type': price.type, 'price': price.price, '_id': price._id })
            })
            pricesFormatted.push({ 'type': '', 'price': '',"_id": 0 })
            this.setState({ pricesFormatted: pricesFormatted, })
        })
    }
    updatePrice = (index, price, type) => {
        axios.post('/api/prices/set', { id: index, price: price, type: type }).then((res) => {
        })

    }
    updateInput = (e, type, id) => {
        let pricesFormatted = this.state.pricesFormatted
        let idx = 0
        for (const price of pricesFormatted) {
            if (price._id == id) {
                break;
            }
            idx++
        }
        pricesFormatted[idx][type] = e.target.value
        this.setState({ 'pricesFormatted': pricesFormatted })
    }
    render() {
        let prices = []
        this.state.pricesFormatted.forEach((price, index) => {
            prices.push(
                <tr key={price._id ? price._id : "0"}>
                    <td onChange={(e) => this.updateInput(e, 'type', price._id)}><input placeholder={price.type} /></td>
                    <td type="number" onChange={(e) => this.updateInput(e, 'price', price._id)}><input placeholder={price.price}></input></td>
                    <td>
                        <Button type='submit' onClick={() => this.updatePrice(price._id, price.price, price.type)}>
                            Update
                        </Button>
                    </td>
                </tr>
            )
        })
        let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <div>
                <Card style={{ margin: '30px' }}>

                    <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: 'center' }}>
                        Prices
                    </Card.Header>
                    <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ 'margin': '0px' }} >
                        <Table  className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ 'margin': '0px' }} bordered>
                            <thead  >
                                <tr className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}  >
                                    <th>Type</th>
                                    <th>Price</th>
                                    <th>Update</th>
                                </tr>
                            </thead>
                            <tbody >
                                {prices}
                            </tbody>
                        </Table>
                    </Card.Body>
          
                </Card>


            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminPrices);